<template>
    <div style="">
        <div style="display:grid; place-items: center;width:100%;height:100%;background-color: rgba(0,0,0,0.3);">
            <div style="background-color: white; width:350px; border-radius:12px;box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.25);">
                <div style="position:relative; padding-top:20px;">
                    <img :src="require('@/assets/img/upload_guide_top.jpg')" style="width:100%;">
                    <div style="position:absolute; padding:10px; color:#210F03; font-size:16px; font-weight:bold; left:10px; top:10px;" @click="close">닫기</div>
                </div>
                <div style="text-align:center; font-size:20px; font-weight:bold; line-height:26px; margin-top:5px;">훈련 영상 업로드 전<br>꼭 확인해주세요!</div>
                <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <img style="width: 22px;" :src="require('@/assets/img/warning.png')" alt="">
                    <div style="color:#E80205; font-size:12px; font-weight:600;text-align:center;margin-top:5px;">주제와 다른 영상은 훈련량에 반영되지 않을 수 있어요</div>
                </div>
                <div class="each_row" style="margin-top:14px;">
                    <div class="image_wrap" style="">
                        <img :src="require('@/assets/img/upload_guide_phone_vertical.png')" style="width:30px;">
                    </div>
                    <div style="flex:1;">
                        <div class="label">영상 방향</div>
                        <div class="explanation"><span class="strong">세로 촬영</span>을 권장합니다.</div>
                    </div>
                </div>
                <div class="each_row" style="">
                    <div class="image_wrap" style="">
                        <img :src="require('@/assets/img/upload_guide_phone_run.png')" style="width:30px;">
                    </div>
                    <div style="flex:1;">
                        <div class="label">영상 구도</div>
                        <div class="explanation"><span class="strong">머리부터 발끝까지</span>영상에 다 나오게 찍어주세요</div>
                    </div>
                </div>
                <div class="each_row" style="">
                    <div class="image_wrap" style="">
                        <img :src="require('@/assets/img/upload_guide_time.png')" style="width:30px;">
                    </div>
                    <div style="flex:1;">
                        <div class="label">영상 시간</div>
                        <div class="explanation"><span class="strong">최대 3분</span>을 넘지 않도록 해주세요</div>
                    </div>
                </div>
                <div class="each_row" style="border-bottom:1px solid #F4F4F4;">
                    <div class="image_wrap" style="">
                        <img :src="require('@/assets/img/upload_guide_notice.png')" style="width:30px;">
                    </div>
                    <div style="flex:1;">
                        <div class="label">주의 사항</div>
                        <div class="explanation"><span class="strong">본인의 훈련 영상</span>만 업로드해 주세요</div>
                    </div>
                </div>
                <div style="text-align:center;display:grid;place-items: center; margin-top:10px;">
                    <div style="background: #FF7111;box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);border-radius: 12px; font-size:24px; font-weight:bold; color:white;width:156px; padding:14px 20px;" @click="complete">준비 완료</div>
                </div>
                <div style="height:20px;"></div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "UploadGuidePopup",
        props : {
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        data(){
            return {

            }
        },
        methods : {
            close(){
                this.$GlobalStore.closeLastModal();
            },
            complete(){
                console.log('complete')
                this.close();
                this.completeAction();
            }
        }
    }
</script>

<style scoped>
    .each_row{display:flex; padding:10px 20px 10px 30px;  border-top:1px solid #F4F4F4;}
    .image_wrap{width:60px; display:grid; place-items: center; height:58px;}
    .label{font-weight:bold; font-size:16px; margin-top:10px; }
    .explanation{font-size:12px; font-weight:500; color:#808080; margin-top:8px; white-space: nowrap;}
    .strong{font-weight:bold; color:#FF7111; font-size:12px;}
</style>